// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';
import {cl} from "./common";

document.addEventListener("DOMContentLoaded", function (){
	// init Swiper hier if needed:
	//https://swiperjs.com/get-started
	cl('Swiper Library init');
	const swiper = new Swiper();
})

document.addEventListener('DOMContentLoaded', function () {
	var projectSwiper = new Swiper('.post-slider', {
		//autoHeight: true,
		//loop: true,
		//noSwiping: true,
		//noSwipingClass: 'no-swipe-element',
		spaceBetween: 32,
		slidesPerView: "auto",
		speed: 1000,
		//centeredSlides: true,
		//keyboard: {
		//	enabled: true,
		//	onlyInViewport: false,
		//},
		navigation: {
			enabled: true,
			nextEl: '.ps-btn-next',
			prevEl: '.ps-btn-prev',
		},
	});
});

document.addEventListener('DOMContentLoaded', function () {
	var projectSwiper = new Swiper('.chronik-slider', {
		loop: true,
		slidesPerView: "auto",
		spaceBetween: 32,
		centeredSlides: true,
		speed: 1200,
		navigation: {
			nextEl: '.chr-btn-next',
			prevEl: '.chr-btn-prev',
		},
	});
});

/*
document.addEventListener('DOMContentLoaded', function () {
	var gallerySwiper = new Swiper('.image-gallery', {
		//autoHeight: true,
		//loop: true,
		slidesPerView: "auto",
		spaceBetween: 32,
      	//centeredSlides: true,
		//pagination: {
			//el: '.swiper-pagination',
			//clickable: true,
		//},
		//keyboard: {
		//	enabled: true,
		//	onlyInViewport: false,
		//},
		navigation: {
			nextEl: '.ig-btn-next',
			prevEl: '.ig-btn-prev',
		},
	});
});
*/

/* Opt-in for Chronik Slider */
document.addEventListener("DOMContentLoaded", function () {
    // Prüfen, ob das div mit der ID "chronikSlider" existiert
    const slider = document.getElementById("chronikSlider");
    if (!slider) return; // Script abbrechen, wenn das Element fehlt

    const button = document.getElementById("showChronikSlider");
    const overlay = document.getElementById("chronikSliderOverlay");

    if (button && overlay) {
        button.addEventListener("click", function () {
            overlay.style.transition = "opacity 1.5s ease";
            overlay.style.opacity = "0";

            setTimeout(() => {
                overlay.style.display = "none";
                slider.style.position = "relative";
                slider.style.opacity = "0";
                slider.style.transition = "opacity 1.5s ease";
                slider.style.opacity = "1";
            }, 500);
        });
    } else {
        console.warn("Button or overlay not found.");
    }
});

/* Triggers 3 Animations for Chronik Slider Nav */
document.addEventListener("DOMContentLoaded", function () {
	const hoverDivs = [
		document.getElementById("chronikSliderHover1"),
		document.getElementById("chronikSliderHover2"),
		document.getElementById("chronikSliderHover3")
	];
	
	const nextBtn = document.querySelector(".chr-btn-next");
	const prevBtn = document.querySelector(".chr-btn-prev");
	
	let clickCount = 0; 
	
	function handleClick() {
		const currentIndex = clickCount % hoverDivs.length; 
		const previousIndex = (clickCount - 1 + hoverDivs.length) % hoverDivs.length; 
	
		hoverDivs.forEach(div => div.classList.remove("fade-in", "fade-out"));

		if (clickCount > 0) {
			hoverDivs[previousIndex].classList.add("fade-out");
		}
	
		hoverDivs[currentIndex].classList.add("fade-in");
	
		clickCount++;
	}

	[nextBtn, prevBtn].forEach(button => {
		button.addEventListener("click", handleClick);
	});
	
});

/* Triggers Animation for Chronik Slider Nav 
document.addEventListener("DOMContentLoaded", function () {
	const chronikSliderHover = document.getElementById("chronikSliderHover1");
	const nextBtn = document.querySelector(".chr-btn-next");
	const prevBtn = document.querySelector(".chr-btn-prev");
	let removeTimeout;
	
	function addHoverClass() {
		clearTimeout(removeTimeout); 
		chronikSliderHover.classList.add("fade-in-out");
	}
	
	function removeHoverClass() {
		removeTimeout = setTimeout(() => {
			chronikSliderHover.classList.remove("fade-in-out");
		}, 1200); // Duration
	}
	
	[nextBtn, prevBtn].forEach(button => {
		button.addEventListener("mousedown", addHoverClass);
		button.addEventListener("mouseup", removeHoverClass);
		button.addEventListener("mouseleave", removeHoverClass);
	});
	
});
*/
